import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { RoutePath } from '../app/app.constants';
import {
  trackAdobeAction,
  trackNewRelicAction
} from '../app/app-state-actions.utilities';
import {
  AdobeAnalyticsAction,
  AdobeAnalyticsButtonType
} from '../../models/adobe-analytics.models';
import { NewRelicAnalyticsAction } from '../../models/new-relic-analytics.models';
import { RecommendationContentTypeDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { AppState } from '../app/app-state.types';
import { AppContext } from '../app/AppProvider.component';

export interface BackToPlanButtonProps {
  appStateRef: React.MutableRefObject<AppState>;
  recommendationId?: number;
  contentType?: RecommendationContentTypeDto;
}

export const BackToPlanButton: React.FC<BackToPlanButtonProps> = ({
  appStateRef,
  recommendationId,
  contentType
}) => {
  const history = useHistory();
  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;

  const handleClick = () => {
    trackAdobeAction({
      appStateRef,
      actionProps: {
        action: AdobeAnalyticsAction.BUTTON_CLICK,
        pageData: {
          buttonType: `plp:${AdobeAnalyticsButtonType.BUTTON}:backToPersonalizedLearningPlan`,
        }
      }
    });
    trackNewRelicAction({
      appStateRef,
      actionProps: {
        action: NewRelicAnalyticsAction.BACK_TO_PLP_CLICKED,
        props: {
          recommendationId,
          contentType,
          remediationAssignmentId: baseState.remediationAssignmentWithSources?.remediationAssignment?.id,
          assessmentId: baseState.eolsAssessment?.id
        }
      }
    });
    history.push(RoutePath.REMEDIATION_STUDENT_HOME);
  };

  return (
    <button
      type="button"
      className="u-els-anchorize u-els-debuttonize"
      onClick={handleClick}
    >
      Back to plan
    </button>
  );
};
